import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { SessionUser } from '@katsquare/types';
import { getMe, logout as apiLogout } from '../../lib/api';

export const SESSION_KEY = ['session'] as const;

/** Loads the current user (null when signed out). */
export function useSession() {
  const query = useQuery<SessionUser | null>({
    queryKey: SESSION_KEY,
    queryFn: getMe,
    staleTime: 60_000,
  });
  return {
    user: query.data ?? null,
    isLoading: query.isPending,
    isError: query.isError,
  };
}

/** Returns a logout handler that clears session + cached data. */
export function useLogout() {
  const queryClient = useQueryClient();
  return async () => {
    await apiLogout().catch(() => undefined);
    queryClient.setQueryData(SESSION_KEY, null);
    await queryClient.invalidateQueries();
  };
}
